import { enableProdMode, importProvidersFrom } from '@angular/core';
import { AppModule } from './app/app.module';
import { environment } from '@env/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';

if (environment.production) {
  window.console.log = () => {};
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [importProvidersFrom(AppModule)]
});
